<template>
  <div :id="groupId">
    <div v-for="attr_field in fields" v-bind:key="attr_field.id">
      <div
        v-if="
          attr_field.type == 'text' ||
          attr_field.type == 'email' ||
          attr_field.type == 'link' ||
          attr_field.type == 'number'
        "
      >
        <form-control-input
          :ref="inputEl.itemRefs"
          :label="attr_field.name"
          :type="attr_field.type"
          :code="attr_field.code"
          :name="attributeId(attr_field)"
          :required="false"
          :public="toBool(attr_field.public)"
          :hidden="attr_field.hidden"
          :parentFormId="parentFormId"
          :prefixId="elementPrefixId"
          v-on:validate="onValidatedFormField"
          :reload="resetTrigger"
        />
      </div>
      <div v-else-if="attr_field.type == 'valuelist' || attr_field.type == 'select'">
        <form-control-select
          :ref="selectEl.itemRefs"
          :label="attr_field.name"
          :name="attributeId(attr_field)"
          :code="attr_field.code"
          :required="false"
          :public="toBool(attr_field.public)"
          :defaultvalue="[attr_field.default_value]"
          :hidden="attr_field.hidden"
          :multiselect="attr_field.multiselect == 1"
          :options="attr_field.values"
          :prefixId="elementPrefixId"
          v-on:validate="onValidatedFormField"
          :parentFormId="parentFormId"
          :allowClear="true"
          :reload="resetTrigger"
          :dependantvalues="allAttributeValuesByCode"
        />
      </div>
      <div v-else-if="attr_field.type == 'checkbox'">
        <form-control-checkbox
          :ref="checkboxEl.itemRefs"
          :label="attr_field.name"
          :name="attributeId(attr_field)"
          :code="attr_field.code"
          :required="false"
          :public="toBool(attr_field.public)"
          :hidden="attr_field.hidden"
          :prefixId="elementPrefixId"
          :defaultvalue="toBool(overrideDefaultValues[attr_field.filter_name] || attr_field.default_value)"
          v-on:validate="onValidatedFormField"
          :parentFormId="parentFormId"
          :reload="resetTrigger"
        />
      </div>
      <div v-else-if="attr_field.type == 'textarea'">
        <form-control-textarea
          :ref="textareaEl.itemRefs"
          :label="attr_field.name"
          :name="attributeId(attr_field)"
          :code="attr_field.code"
          :required="false"
          :public="toBool(attr_field.public)"
          :hidden="attr_field.hidden"
          :prefixId="elementPrefixId"
          v-on:validate="onValidatedFormField"
          :parentFormId="parentFormId"
          :reload="resetTrigger"
        />
      </div>
      <div v-else>
        <i>Unknown type "{{ attr_field.type }}" for attribute "{{ attr_field.code }}"!</i>
      </div>
    </div>
  </div>
</template>
<script>
import FormControlInput from '@/components/general/FormControl/Input';
import FormControlSelect from '@/components/general/FormControl/Select';
import FormControlCheckbox from '@/components/general/FormControl/Checkbox';
import FormControlTextarea from '@/components/general/FormControl/TextArea';
import useConverter from '@/composables/general/useConverter';
import { toRefs } from '@vue/reactivity';
import { computed } from '@vue/runtime-core';
import { ref } from 'vue';

export default {
  name: 'form-control-search-attributes',

  emits: ['validate'],
  components: {
    FormControlInput,
    FormControlSelect,
    FormControlCheckbox,
    FormControlTextarea,
  },

  props: {
    fields: {
      required: true,
      type: Array,
    },
    groupName: {
      required: false,
      type: String,
      default: '',
    },
    parentFormId: {
      required: false,
      type: String,
      default: '',
    },
    elementPrefixId: {
      required: false,
      type: String,
      default: 'wdw-bms-attr',
    },
    overrideDefaultValues: {
      required: false,
      type: Object,
      default: function () {
        return {};
      },
    },
    resetTrigger: {
      required: false,
      type: Number,
      default: 0,
    },
  },

  setup(props, context) {
    const { groupName, elementPrefixId } = toRefs(props);
    const inputRefs = ref([]);
    const inputEl = { itemRefs: inputRefs };
    const selectRefs = ref([]);
    const selectEl = { itemRefs: selectRefs };
    const checkboxRefs = ref([]);
    const checkboxEl = { itemRefs: checkboxRefs };
    const textareaRefs = ref([]);
    const textareaEl = { itemRefs: textareaRefs };

    const { toBool, toArray } = useConverter();
    const allAttributeValuesByCode = ref({});

    //+--------------------------+
    //|     other methods        |
    //+--------------------------+
    function resetElements() {
      selectRefs.value.forEach(select => {
        select.resetSelect();
      });
      checkboxRefs.value.forEach(checkbox => {
        checkbox.setValue(false);
      });

      [inputRefs.value, textareaRefs.value].flat(1).forEach(value => {
        value.setValue();
      });
    }
    const attributeId = attr => {
      return 'attribute' + attr.id;
    };
    context.expose({ resetElements });
    //+---------------------------+
    //|         computed          |
    //+---------------------------+
    const groupId = computed(() => {
      return elementPrefixId.value + '-attributegroup-' + groupName.value;
    });

    const onValidatedFormField = fieldValue => {
      // T22832: Save all validated attribute values
      allAttributeValuesByCode.value[fieldValue.code] = fieldValue.value;
      // Pass validation to the parent
      // NOTE: you can also pre-validate subgroup of attributes here before passing back to parent
      context.emit('validate', fieldValue);
    };
    return {
      inputEl,
      selectEl,
      checkboxEl,
      textareaEl,
      // Computed
      groupId,
      // other methods
      attributeId,
      toBool,
      toArray,
      // Listeners
      onValidatedFormField,
      allAttributeValuesByCode,
    };
  },
};
</script>
